module.exports = __webpack_public_path__ + "static/Unisel4-55bf70f97d3a054f90302aeaa25ac1a8.jpg";